module.exports = __webpack_public_path__ + "img/YouthMissionBG.c47d1f99.jpg";